
document.querySelector('.hamburger').addEventListener('click', function(e) {
	/*
	const scrollY = window.scrollY;
	document.body.style.position = 'fixed';
	document.body.style.top = -1 * scrollY + 'px';
	*/
	document.body.classList.add('--menu-mobile-open');
	document.querySelector('.mobile-menu').classList.add('--open');

});

document.querySelector('.mobile-menu .close').addEventListener('click', function(e) {
	/*
	const scrollY = document.body.style.top;
	document.body.style.position = '';
	document.body.style.top = '';
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
	*/
	document.body.classList.remove('--menu-mobile-open');
	document.querySelector('.mobile-menu').classList.remove('--open');

});